import { useTranslation } from "react-i18next";
import { Space, Table } from "antd";
import usePriceFormulas from "@/hooks/usePriceFormulas";
import { PriceFormula } from "@/root/models/priceFormula";
import useModalOpen from "@/hooks/useModalOpen";
import PriceFormulaTableActions from "./components/PriceFormulaTableActions";
import CreatePriceFormula from "./components/CreatePriceFormula";

const PriceFormulas = () => {
  const { t } = useTranslation();
  const { priceFormulas, getPriceFormulasLoading } = usePriceFormulas({});

  const { modal, onHandleCancel, onEditSuccess, isModalOpen } = useModalOpen();

  const priceFormulasColumn = [
    {
      title: t("Назва"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: t("Формула"),
      dataIndex: "formula",
      key: "formula",
    },
    {
      title: "",
      key: "action",
      render: (_: any, priceFormula: PriceFormula) => (
        <PriceFormulaTableActions
          priceFormula={priceFormula}
          modal={modal}
          onEditSuccess={onEditSuccess}
          onCancel={onHandleCancel}
          onModalOpen={() => {
            isModalOpen(priceFormula.priceFormulaUUID);
          }}
        />
      ),
    },
  ];

  return (
    <Space direction="vertical">
      <CreatePriceFormula />
      <div style={{ display: "flex", gap: 10 }}>
        <Table
          style={{ userSelect: "none" }}
          columns={priceFormulasColumn}
          dataSource={priceFormulas.map((p) => ({
            ...p,
            key: p.priceFormulaUUID,
          }))}
          pagination={false}
          loading={getPriceFormulasLoading}
          onRow={(priceFormula) => ({
            onDoubleClick: () => isModalOpen(priceFormula.priceFormulaUUID),
          })}
        />
      </div>
    </Space>
  );
};

export default PriceFormulas;
